export const formatAddress = (addressComponents) => {
    return addressComponents
        .filter((component) => component !== undefined && component !== null && component !== '')
        .map((component, index, array) => {
            return index === array.length - 2 && array[index + 1] !== '' ? component : component + ', '
        })
        .join(' ')
        .replace(/,\s*$/, '')
}
